import request from '../utils/request'
//密码登录
export function passwordLogin(mobile,password) {
    return request.post('/api/passwd_login',{"mobile":mobile,"password":password})
}
//获取验证码
export function validation(img_code,uniqid,mobile,code_type) {
    return request.post('/api/send_sms_code',{"img_code":img_code,"uniqid":uniqid,"mobile":mobile,"code_type":code_type})

}
// 验证码登录
export function verifyLogin(mobile,captcha) {
    return request.post('/api/sms_login',{"mobile":mobile,"captcha":captcha})
}

//忘记密码
export function forgetPassword(mobile,captcha,password) {
    return request.post('/api/passwd_forget',{"mobile":mobile,"captcha":captcha,"password":password})
}

//用户注册
export function userRegistration(mobile,captcha,password,promotion_code) {
    return request.post('/api/user_register',{"mobile":mobile,"captcha":captcha,"password":password,"promotion_code":promotion_code})
}

//图形验证码
export function figureVerification(unid) {
    return request.post('/api/captcha_url',{"unid":unid})
}

//获取企业logo
export function getLogo(data) {
    return request({
        url:'/api/get_com_logo',
        method:'post',
        data
    })
}
